import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin, FaGithub, FaTwitter } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-dark text-light pt-5 pb-3 mt-5 border-top border-secondary">
      <div className="container">
        <div className="row text-center text-md-start">
          {/* About Section */}
          <div className="col-md-4 mb-4">
            <h5 className="text-warning mb-3 fw-bold">MRDEVWORKS</h5>
            <p className="small">
              We craft modern custom, wordpress, e-commerce website solutions, seo, creative logos and
              targeted paid ad campaigns to reach the right audience and boost sales.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h6 className="text-uppercase mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              <li>
                <a href="#" className="text-light text-decoration-none d-block mb-1">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-light text-decoration-none d-block mb-1">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-light text-decoration-none d-block mb-1">
                  Contact
                </a>
              </li>
              <li>
                <a href="#about" className="text-light text-decoration-none d-block mb-1">
                  About
                </a>
              </li>
            </ul>
          </div>

          {/* Social Icons */}
          <div className="col-md-4 mb-4 text-center text-md-start">
            <h6 className="text-uppercase mb-3">Follow Us</h6>
            <div className="d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://x.com/M_abdullah_628?t=mtkE8FjMjUNXo3L00WJBEg&s=09" target="_blank" 
  rel="noopener noreferrer" className="text-light fs-4">
                <FaTwitter />
              </a>
              <a href="https://www.instagram.com/mrdevworks?igsh=Mnk3cW40cm1jYXVp" target="_blank" 
  rel="noopener noreferrer" className="text-light fs-4">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/in/muhammad-abdullah-coder/" target="_blank" 
  rel="noopener noreferrer" className="text-light fs-4">
                <FaLinkedin />
              </a>
              <a href="https://github.com/Muhammad-Abdullah-Coder" target="_blank" 
  rel="noopener noreferrer" className="text-light fs-4">
                <FaGithub />
              </a>
            </div>
          </div>
        </div>

        <hr className="border-secondary" />
        <div className="text-center small">
          &copy; {new Date().getFullYear()} <strong>MrDevWorks</strong>. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
